import React from 'react'
import { Link } from 'react-router-dom'
import { Card, CardBody, Heading } from '@liquidcollectibles/uikit'
import styled from 'styled-components'
import { ethers } from 'ethers'
import { NftMetadata } from 'config/constants/types'
import { getCollectionInfo } from 'state/collectibles/hooks'
import Preview from './_components/ImgPreview'

const licoImageSrc = '/images/lico-token.svg'

const Tags = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`

const AuthorTag = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 6px 2px 2px;
  background: #424242;
  border-radius: 24px;
  margin-right: 12px;
`

const AuthorLogo = styled.div<{ backgroundImage?: string }>`
  height: 19px;
  width: 19px;
  margin-right: 6px;
  background-image: url('${(props) => props.backgroundImage || licoImageSrc}');
  background-size: cover;
  background-position: center;
`
const AuthorName = styled.h3`
  color: rgba(255, 255, 255, 0.87);
  font-size: 12px;
`

export interface NftCardProps {
  nft: NftMetadata
  collectionAddress: string
  canClaim?: boolean
  tokenIds?: number[]
  onClaim?: () => Promise<ethers.providers.TransactionResponse>
  refresh?: () => void
  handleSelect: (nftIndex) => void
}

const SimpleNftCard: React.FC<NftCardProps> = ({ collectionAddress, nft }) => {
  const collection = getCollectionInfo(collectionAddress)
  return (
    <Link to={`/collection/${collectionAddress}/token/${nft.tokenId}`}>
      <Card style={{ border: '1px solid rgb(66, 66, 66)', borderRadius: 6 }}>
        <Preview nft={nft} collection={collection} />
        <CardBody p="16px">
          <Tags>
            <AuthorTag>
              <AuthorLogo
                backgroundImage={
                  collection.category === 'Original'
                    ? licoImageSrc
                    : `/images/tokens/${collection.vaultTokenAddress}.png`
                }
              />
              <AuthorName>{collection.author}</AuthorName>
            </AuthorTag>
          </Tags>
          <Heading>{nft.name}</Heading>
        </CardBody>
      </Card>
    </Link>
  )
}

export default SimpleNftCard
